/**
 * ZenMarkup Privacy Analytics — Table Builder module.
 *
 * Generic DOM helpers for widget content: multi-column tables,
 * widget body injection, and empty-state placeholders.
 */

/**
 * Build a multi-column list using zmpa-list markup.
 *
 * @param {string[]} headers  Column headers (first = name, rest = counts).
 * @param {Array}    rows     Array of { name, count, extra: [val, ...] }.
 * @return {HTMLElement}
 */
export function buildMultiColTable(headers, rows) {
	const wrap = document.createElement('div');
	wrap.className = 'zmpa-list';

	const header = document.createElement('div');
	header.className = 'zmpa-list-header';
	headers.forEach(function (h) {
		const span = document.createElement('span');
		span.textContent = h;
		header.appendChild(span);
	});
	wrap.appendChild(header);

	rows.forEach(function (row) {
		const item = document.createElement('div');
		item.className = 'zmpa-list-row';

		const name = document.createElement('span');
		name.className = 'zmpa-list-name';
		name.textContent = row.name;
		name.title = row.name;
		item.appendChild(name);

		const count = document.createElement('span');
		count.className = 'zmpa-list-count';
		count.textContent = row.count;
		item.appendChild(count);

		if (row.extra) {
			row.extra.forEach(function (val) {
				const col = document.createElement('span');
				col.className = 'zmpa-list-count';
				col.textContent = val;
				item.appendChild(col);
			});
		}

		wrap.appendChild(item);
	});

	return wrap;
}

/**
 * Render content into a widget body, replacing previous content.
 *
 * @param {string}      widgetName  The data-el value of the widget container.
 * @param {HTMLElement}  content     Element to insert.
 */
export function setWidgetContent(widgetName, content) {
	const widget = document.querySelector('[data-el="' + widgetName + '"]');
	if (!widget) {
		return;
	}

	const body = widget.querySelector('[data-el="widget-body"]');
	if (!body) {
		return;
	}

	body.innerHTML = '';
	body.appendChild(content);
}

/**
 * Create an empty-state placeholder element.
 *
 * @param {string} message
 * @return {HTMLElement}
 */
export function emptyState(message) {
	const div = document.createElement('div');
	div.className = 'zmpa-empty';
	div.textContent = message;
	return div;
}
